<span class="relative flex flex-col w-full h-full">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'label_missing_information' | translate }}</div>
        <div class="absolute top-0 right-0 pt-4 pr-4"></div>
    </div>

    @if (false) {
    <div class="p-6" mat-dialog-content>
        <div class="grid sm:grid-cols-4 gap-6 w-full mt-[220px]">
            <div class="col-span-4">
                <app-loader-inline class="float-left mt-[50px]"></app-loader-inline>
            </div>
        </div>
    </div>
    } @if (true) {
    <form [formGroup]="form" class="mx-8 my-4">
        <div>{{ 'info_add_originating_system_application_information' | translate }}</div>
        <mat-divider class="my-4"></mat-divider>
        @if (form) {
        <div class="grid grid-cols-1 w-full gap-4 margin-top margin-bottom-10">
            <mat-form-field class="fuse-mat-no-subscript col-span-2 sm:col-span-1 lg:flex-1 lg:max-w-sm">
                <mat-label> {{ 'info_application_id_from_originating_system' | translate }} </mat-label>
                <input formControlName="originatingSystemApplicationId" matInput />
            </mat-form-field>
            <mat-form-field>
                <mat-label> {{ 'label_originating_system' | translate }} </mat-label>
                <mat-select formControlName="originatingSystem" placeholder="Kerfi">
                    @for (option of systemOptions; track option) {
                    <mat-option [value]="option.value"> {{ option.label | translate }} </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        }
        <div class="mt-4 flex justify-end">
            <button (click)="submit()" mat-flat-button [color]="'primary'" [disabled]="!form.valid || !formEnabled">
                @if (formEnabled) {
                <span>{{ 'label_save_document' | translate }}</span>
                } @if (!formEnabled) {
                <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                }
            </button>
        </div>
    </form>
    }
</span>
